import Environment from '../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../BaseService';

const RESOURCE = 'featured-apps';

export interface IFeaturedApp {
  app_key?: string;
  title?: string;
  type: string;
}

interface IGetFeaturedApps extends IUri {
  appKey: string;
}

interface IGetFeatureAppsResponse extends IHttpResponse {
  body?: IFeaturedApp[];
}

export default function ({
  appKey,
}: IGetFeaturedApps): Promise<IGetFeatureAppsResponse> {
  const url = buildUrl({
    host: Environment.feedsService,
    resource: RESOURCE,
    id: appKey,
  });

  return BaseService.Get({
    url,
  });
}
